export const environment = {
    production: false,
    authorizationServiceUrl: 'https://us-central1-starkey-engage-qa.cloudfunctions.net',
    cloudCoreApiUrl: 'https://core-qa.telehearportal.com/api/v1',
    //This key has to be exposed to show google maps so there's no point in grabbing it from secret manager
    googleMapsApiKey: 'AIzaSyDOLDosdNeVpk8HbxNcMt69EyJ8NofpUmc',
    authDomain: 'engage-fall-management-qa.web.app',
    projectId: 'starkey-engage-qa'
};
